import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import {
  HttpClientModule
} from '@angular/common/http';
import { LoaderModule } from './components/loader/loader.module';
import {
  MatNativeDateModule,
} from '@angular/material';
import { NgModule } from '@angular/core';
import { OnlineStatusComponent } from './components/online-status/online-status.component';
import {
  PopupModule
} from './components/popup';
import { SharedModule } from './modules/shared/shared.module';
import { SuccessPopupModule } from './components/success-popup/success-popup.module';
import { ToastNotificationModule } from './components/toast-notification/toast-notification.module';
import { WebAccessPopupModule } from './components/web-access-popup/web-access-popup.module';
import { environment } from '../environments/environment';
import { httpInterceptorProviders } from './services/interceptor';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';

@NgModule({
  declarations: [
    AppComponent,
    OnlineStatusComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule,
    LoaderModule,
    ToastNotificationModule,
    // MatDialogModule,
    WebAccessPopupModule,
    MatNativeDateModule,
    PopupModule,
    SharedModule,
    SuccessPopupModule,
  ],
  providers: [httpInterceptorProviders],
  bootstrap: [AppComponent]
})
export class AppModule {
}

